import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('../activity/winter-vacation-2023/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/winter-vacation-activity-2023',
  name: 'winter_vacation_activity_2023',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '寒假作业',
    ignoreLogin: true,
  },
}

export default [indexRoute]

export function navigateToWinterVacationActivity(router: VueRouter, qd?: string) {
  router.push({ name: indexRoute.name, query: { qd } })
}
